import type { LucideIcon } from "lucide-react";

export function MetricCard({
  label,
  value,
  note,
  tone = "neutral",
  icon: Icon,
  delay = 0,
}: {
  label: string;
  value: string;
  note: string;
  tone?: "neutral" | "good" | "warning" | "danger" | "accent";
  icon: LucideIcon;
  delay?: number;
}) {
  return (
    <article
      className={`metric-card tone-${tone} enter`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="metric-card-top">
        <span className="metric-icon">
          <Icon size={16} />
        </span>
        <span className="metric-note">{note}</span>
      </div>
      <span className="metric-label">{label}</span>
      <strong>{value}</strong>
    </article>
  );
}
